import { Controller } from "@hotwired/stimulus"

export default class CheckboxSelectAllController extends Controller {
  static targets = ["selectAll", "item"]

  connect() {
    this.updateSelectAllCheckbox()
  }

  toggleAll(event) {
    const isChecked = event.target.checked
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = isChecked
    })

    this.updateSelectAllCheckbox()
    this.dispatch("select-all-changed", { target: event.target })
  }

  toggleItem(event) {
    this.updateSelectAllCheckbox()
    this.dispatch("item-changed", { target: event.target })
  }

  updateSelectAllCheckbox() {
    const total = this.itemTargets.length
    const checked = this.itemTargets.filter((cb) => cb.checked).length
    const someIndeterminate = this.itemTargets.some((cb) => cb.indeterminate)

    if (checked === total) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else if (checked > 0 || someIndeterminate) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
  }
}
